export default __webpack_public_path__ + "static/cooperation1-c2d100fc85f5462b3f04109ca3d18b4f.png";